module.exports = __webpack_public_path__ + "img/uyuni2.27cdbe77.jpg";